/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Row, Col, Modal } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from 'components/base/Button';
import SearchProductInventory from './SearchProductInventory';
import productSearchService from 'service/productSearch';
import { showAlert } from 'store/alert/alert.thunk';
import inventoryItemService from 'service/inventoryItem';
import './styles.scss';

interface SelectionProductProps {
  tableData?: any;
  setTableData?: any;
}

const SelectionProduct = ({
  tableData,
  setTableData
}: SelectionProductProps) => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { inventory_pid, warehouse_pid } = state;

  console.log('tableData', tableData);

  const { register, getValues, reset, control, watch } = useForm();
  const dispatch: Dispatch<any> = useDispatch();
  const inputRef = useRef<HTMLInputElement | any>();
  const inputBarcodeRef = useRef<HTMLInputElement | any>();

  const [openSearch, setOpenSearch] = useState(false);
  const [searchedValue, setSearchedValue] = useState<any>('');
  const [focusToInput, setFocusToInput] = useState(false);
  const [updatedBalance, setUpdatedActualBalance] = useState('');
  const [disabledSearchinput, setDisabledSearchInput] = useState(false);

  const handleGetProduct = (e: any) => {
    if (e.key === 'Enter') {
      if (!searchedValue) {
        dispatch(showAlert({ title: t('barcode_not_found') }));
        reset({
          product_name: '',
          current_balance: '',
          current_inventory_balance: ''
        });
      }

      if (searchedValue !== '' && warehouse_pid !== 0) {
        setDisabledSearchInput(true);
        productSearchService
          .getListProduct({
            offset: 0,
            limit: 20,
            warehouse_pid: warehouse_pid,
            barcode: searchedValue ? searchedValue : undefined
          })
          .then((res: any) => {
            console.log('Res', res);
            if (res?.products) {
              const packageQuantity = res?.products?.[0].package_quantity || 1;

              const totalQuantity = res?.products?.[0]?.total_quantity
                ? Number(res?.products?.[0]?.total_quantity.toFixed(3))
                : 0;

              const fullPackages = Math.floor(totalQuantity / packageQuantity);
              const remainingQuantity = totalQuantity % packageQuantity;
              const quantityDisplayTotal = `${fullPackages}/${remainingQuantity}`;

              const computed = {
                product_name: res?.products?.[0]?.name ?? '',
                current_balance:
                  res?.products?.[0]?.nomenclature?.measure_unit_kind_pid === 1
                    ? quantityDisplayTotal
                    : res?.products?.[0]?.total_quantity ?? 0,
                nomenclature_id: res?.products?.[0]?.nomenclature_id,
                nomenclature_pid: res?.products?.[0]?.nomenclature_pid || 0,
                current_inventory_balance:
                  tableData[res?.products?.[0]?.barcode]?.quantity_fact ?? 0,
                currency_id: res?.products?.[0]?.currency_id,
                currency_pid: res?.products?.[0]?.currency_pid || 0,
                price_in: res?.products?.[0]?.price_in ?? 0,
                product_id: res?.products?.[0]?.id,
                product_pid: res?.products?.[0]?.pid || 0,
                package_quantity: res?.products?.[0]?.package_quantity || 1,
                measure_unit_kind:
                  res?.products?.[0].nomenclature?.measure_unit?.id,
                measure_unit_id:
                  res?.products?.[0].nomenclature?.measure_unit?.id,
                measure_unit_pid:
                  res?.products?.[0].nomenclature?.measure_unit?.pid || 0
              };

              if (inputRef.current) {
                inputRef?.current.focus();
                inputRef?.current.select();
              }
              reset(computed);
              setDisabledSearchInput(false);
            } else {
              dispatch(showAlert({ title: t('barcode_not_found') }));
              reset({
                product_name: '',
                current_balance: '',
                current_inventory_balance: ''
              });
              setDisabledSearchInput(false);
            }
          });
      }
    }
  };

  const onSubmit = () => {
    const data = getValues();

    if (updatedBalance?.length > 5) {
      if (inputRef.current) {
        setTimeout(() => {
          inputRef.current.select();
        }, 500);
      }
      dispatch(
        showAlert({
          title: t('not_facts')
        })
      );

      return;
    }

    if (
      data?.product_name == null ||
      data?.current_balance == null ||
      data?.current_inventory_balance == null ||
      data?.product_name === '' ||
      data?.current_balance === '' ||
      data?.current_inventory_balance === ''
    ) {
      dispatch(
        showAlert({
          title: t('product_not_added')
        })
      );
      return;
    }

    // Parse the current and updated balance to ensure proper numeric comparison
    const currentInventoryBalance =
      parseFloat(data?.current_inventory_balance) || 0;
    // const updatedBalanceNumber = parseFloat(updatedBalance) || 0;
    const quantityStr = String(updatedBalance);
    let integerPart = 0;
    let numerator = 0;
    let denominator = 0; // Default denominator to 1

    if (quantityStr.includes('/')) {
      [numerator, denominator] = quantityStr.split('/').map(Number);
      integerPart = numerator;
    } else {
      integerPart = +quantityStr;
    }

    const quantityStrCurrentBalance = String(data?.current_balance);
    let integerPartCurrentBalance = 0;
    let numeratorCurrentBalance = 0;
    let denominatorCurrentBalance = 0; // Default denominator to 1

    if (quantityStrCurrentBalance.includes('/')) {
      [numeratorCurrentBalance, denominatorCurrentBalance] =
        quantityStrCurrentBalance.split('/').map(Number);
      integerPartCurrentBalance = numeratorCurrentBalance;
    } else {
      integerPartCurrentBalance = +quantityStrCurrentBalance;
    }

    // Package quantity (fallback to 1 if missing)
    const packageQuantity = +data?.package_quantity || 1;
    // Adjusted quantity
    const adjustedQuantityCurrentBalance = quantityStrCurrentBalance?.includes(
      '/'
    )
      ? integerPartCurrentBalance * packageQuantity + denominatorCurrentBalance
      : integerPartCurrentBalance;

    const adjustedQuantity = quantityStr?.includes('/')
      ? integerPart * packageQuantity + denominator
      : integerPart;

    if (currentInventoryBalance + Number(adjustedQuantity) < 0) {
      dispatch(
        showAlert({
          title: t('quantity_must_not_less_zero')
        })
      );
      return; // Exit early to prevent further processing
    }

    const createdData = {
      quantity: +adjustedQuantityCurrentBalance,
      quantity_actual: currentInventoryBalance + Number(adjustedQuantity),
      nomenclature_pid: data.nomenclature_pid || 0,
      currency_pid: data.currency_pid || 0,
      price_in: data.price_in,
      product_pid: data.product_pid || 0,
      statu_pid: 5
    };

    // const existingProduct = tableData?.[+searchedValue];

    // if (existingProduct) {
    //   inventoryItemService
    //     .updateInventoryItem(tableData[+searchedValue].gupid, {
    //       quantity_actual: createdData?.quantity_actual
    //     })
    //     .then((res: any) => {
    //       if (res) {
    //         dispatch(
    //           showAlert({
    //             title: t('product_successfully_saved'),
    //             type: 'success'
    //           })
    //         );
    //         setTableData((prevTableData: any) => ({
    //           ...prevTableData,
    //           [+searchedValue]: {
    //             gupid: tableData[+searchedValue].gupid,
    //             quantity_fact: createdData?.quantity_actual
    //           }
    //         }));

    //         reset({
    //           scan: '',
    //           product_name: '',
    //           current_balance: '',
    //           current_inventory_balance: '',
    //           actual_balance: ''
    //         });
    //         setSearchedValue('');
    //         setUpdatedActualBalance('');
    //       }
    //     });
    // } else {
    /* prettier-ignore */
    inventoryItemService
        .createInventoryItem({
          inventory_pid: inventory_pid || 0,
          inventory_items: [createdData]
        })
        .then((res: any) => {
          if (res) {
            dispatch(
              showAlert({ title: t('successfully_added'), type: 'success' })
            );
            setTableData((prevTableData: any) => ({
              ...prevTableData,
              [+searchedValue]: {
                gupid: res?.inventory_items[0]?.pid,
                quantity_fact: createdData?.quantity_actual
              }
            }));

            reset({
              scan: '',
              product_name: '',
              current_balance: '',
              current_inventory_balance: '',
              actual_balance: ''
            });
            setSearchedValue('');
            setUpdatedActualBalance("");
          }
        });
  };
  // };

  // const handleClose = () => {
  //   setOpenProduct(false);
  //   refetchInventoryItem();
  // };

  const handleBalanceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;
    const measureUnitId = watch('measure_unit_id');

    // if (newValue.length > 5) {
    //   newValue = newValue.slice(0, 5);
    // }

    if (measureUnitId === '208baabf-b8dd-4e2e-b3a0-05c2f6744052') {
      newValue = newValue.replace(',', '.');
      if (/^-?\d*\.?\d*$/.test(newValue)) {
        setUpdatedActualBalance(newValue);
      }
    } else if (measureUnitId === '443bfff1-61e0-4057-8583-d040dc5a0454') {
      if (/^\d*\/?\d*$/.test(newValue)) {
        setUpdatedActualBalance(newValue);
      }
    } else {
      if (/^-?\d*$/.test(newValue)) {
        setUpdatedActualBalance(newValue);
      }
    }
  };

  useEffect(() => {
    if (inputBarcodeRef.current && searchedValue === '') {
      inputBarcodeRef.current.focus();
    }
  }, [inputBarcodeRef, searchedValue]);

  useEffect(() => {
    if (inputRef.current && focusToInput) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 500);
    }
  }, [focusToInput]);

  return (
    <>
      <Form
        noValidate
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <Row className="mb-2">
          <Col className="modal-rows">
            <Controller
              name="scan"
              control={control}
              render={({ field }) => (
                <Form.Floating className="first-item">
                  <Form.Control
                    {...field}
                    ref={inputBarcodeRef}
                    type="text"
                    value={searchedValue}
                    placeholder={t('scan_barcode')}
                    onChange={e => setSearchedValue(e?.target?.value)}
                    onKeyDown={e => handleGetProduct(e)}
                    onFocus={e => {
                      e.target.select();
                    }}
                    autoComplete="off"
                    disabled={disabledSearchinput}
                  />
                  <label htmlFor="floatingInputCustom">
                    {t('scan_barcode')}
                  </label>
                </Form.Floating>
              )}
            />

            <div className="d-flex justify-content-between gap-2">
              <Button
                className="d-flex align-items-center gap-2"
                variant="primary"
                type="button"
                onClick={() => {
                  setOpenSearch(true);
                  setFocusToInput(false);
                }}
              >
                {t('search')}
              </Button>
            </div>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Floating>
              <Form.Control
                {...register('product_name')}
                type="text"
                placeholder={t('product_names')}
                disabled={true}
                onFocus={e => e.target.select()}
                autoComplete="off"
              />
              <label htmlFor="floatingInputCustom">{t('product_names')}</label>
            </Form.Floating>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Floating>
              <Form.Control
                {...register('current_balance')}
                type="text"
                placeholder={t('current_balance')}
                disabled={true}
                onFocus={e => e.target.select()}
                autoComplete="off"
              />
              <label htmlFor="floatingInputCustom">
                {t('current_balance')}
              </label>
            </Form.Floating>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Floating>
              <Form.Control
                {...register('current_inventory_balance')}
                type="text"
                placeholder={t('current_inventory_balance')}
                disabled={true}
                onFocus={e => e.target.select()}
                autoComplete="off"
              />
              <label htmlFor="floatingInputCustom">
                {t('current_inventory_balance')}
              </label>
            </Form.Floating>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col>
            <Controller
              name="actual_balance"
              control={control}
              render={({ field }) => (
                <Form.Floating>
                  <Form.Control
                    {...field}
                    ref={inputRef}
                    type="text"
                    value={updatedBalance}
                    onChange={handleBalanceChange}
                    placeholder={t('actual_balance')}
                    onFocus={e => e.target.select()}
                    autoComplete="off"
                    onKeyDown={e => {
                      if (e?.key === 'Enter') {
                        onSubmit();
                      }
                    }}
                  />
                  <label htmlFor="floatingInputCustom">
                    {t('actual_balance')}
                  </label>
                </Form.Floating>
              )}
            />
          </Col>
        </Row>

        <Form.Group>
          {/* <Button
            style={{ height: '48px' }}
            type="button"
            variant="outline-secondary"
            onClick={() => handleClose()}
          >
            {t('complete_product_selection')}
          </Button> */}
          <Button
            style={{ height: '48px', width: '100%' }}
            variant="primary"
            type="button"
            onClick={() => onSubmit()}
          >
            {t('add_product')}
          </Button>
        </Form.Group>
      </Form>

      <Modal
        show={openSearch}
        onHide={() => setOpenSearch(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('search_product')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SearchProductInventory
            setOpenSearch={setOpenSearch}
            reset={reset}
            setSearchedValue={setSearchedValue}
            tableData={tableData}
            setFocusToInput={setFocusToInput}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SelectionProduct;
